module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/05-03.7cbcafa9.mp3";